<template>
<div class="p-2 bg-vc-blue-100 rounded-lg inline-flex flex-col gap-2" v-if="allAnswers.length > 0">
  <template v-for="answer in allAnswers">
    <related-users-name :nameValue="answer.data.contact_uid" />
  </template>
</div>
</template>
<script>
import mixin from './_mixin_display'
import RelatedUsersName from './_related_user_name.vue'
export default {
  components: {RelatedUsersName},
  mixins: [mixin],
  skipBasic: true,
}
</script>